<template>
    <div class="container">
        <div class="row justify-content-center">
            <div class="content-container col-11">
                <h2 class="chapter-title" :style="{ color: this.textColor }"> {{ chapterTitle }} </h2>
                <p class="content" v-html="content" :style="styleObject"></p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            content: String,
            chapterTitle: String,
            fontSize: null,
            lineHeight: null,
            fontFamily: null,
            textColor: null
        },
        computed: {
            styleObject() {
                return {
                    fontSize: this.fontSize.toString() + 'px',
                    lineHeight: this.lineHeight.toString() + '%',
                    fontFamily: this.fontFamily,
                    color: this.textColor
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
@import "../styles/components/manga-chapter.scss"
</style>